import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WarehouseMapApiAdapter } from '../adapters/WarehouseMapApiAdapter';

export const useWarehouseGrid = (warehouseId: number) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new WarehouseMapApiAdapter(httpClient);

  return useQuery({
    queryKey: ['warehouse-grid', warehouseId],
    queryFn: () => adapter.getGrid(warehouseId),
    enabled: warehouseId > 0,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
